module.exports = __webpack_public_path__ + "media/images/sp/stores/kyoto/kyoto_sns_06-1b7af0fa6102389d4a78895fda355e70.jpg";